export default {
  All: '<<Tất cả>>',
  Summary: '<<Tổng hợp>>',
  AllId: 'All',
  AllGuid: '00000000-0000-0000-0000-000000000000',
  SummaryGuid: '99999999-9999-9999-9999-999999999999',
  AllInt: -1,
  SummaryId: 'Summary',
  SummaryInt: -2,
  AllText: 'Tất cả',
  SummaryText: 'Tổng hợp',
  None: '<<Không chọn>>',
  NoneText: 'Không chọn',
  NoneId: 'None',
  NoneInt: -3,
};

